export type { AuditTrailsPageProps } from './AuditTrailsPage/AuditTrailsPage';
export { default as AuditTrailsPage } from './AuditTrailsPage/AuditTrailsPage';

export type { AuditSettingsPageProps } from './AuditSettingsPage/AuditSettingsPage';
export { default as AuditSettingsPage } from './AuditSettingsPage/AuditSettingsPage';
